function getBrandConfigPath(region: 'US' | 'CA'): string {
    return region === 'CA' ? '_assets-global/configs/brands-ca.json' : '_assets-global/configs/brands.json';
}

export function getBrandJSON(): string {
    const url = window.location.origin;
    // For local environments
    if (url.includes('localhost')) {
        const assetPathElement = document.getElementById("assetPath") as HTMLInputElement;
        if (assetPathElement) {
            const assetPathValue = assetPathElement.value;
            if (assetPathValue.includes("/US/"))
                return getBrandConfigPath('US');
            else if (assetPathValue.includes("/CA/"))
                return getBrandConfigPath('CA');
        }
        return "Error validating Location";
    }
    // Code for lower environments
    else if (url.includes('nblysbx') || url.includes('nblydev') || url.includes('nblytest') || url.includes('nblyprod')) {
        try {
            if (url.includes('-ca-') || (url.includes('-ca') && url.includes('nblyprod')))
                return getBrandConfigPath('CA');
            else
                return getBrandConfigPath('US');
        } catch {
            return "Error validating Location";
        }
    }
    // Code for production environment
    else {
        try {
            const lastDotIndex = url.lastIndexOf('.');
            const domainExtension = url.substring(lastDotIndex + 1);
            if (domainExtension === "ca")
                return getBrandConfigPath('CA');
            else
                return getBrandConfigPath('US');
        } catch {
            return "Error validating Location";
        }
    }
}

